module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjMiIGhlaWdodD0iMjMiIHZpZXdCb3g9IjAgMCAyMyAyMyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMuNTUzIDExLjQ1Mmw5LjAzNiA5LjAzNWExLjIzMSAxLjIzMSAwIDEgMS0xLjc0MSAxLjc0MmwtOS4wMzYtOS4wMzYtOS4wMzYgOS4wMzZhMS4yMzEgMS4yMzEgMCAxIDEtMS43NDEtMS43NDJsOS4wMzYtOS4wMzUtOS4wMzYtOS4wMzZBMS4yMzEgMS4yMzEgMCAxIDEgMi43NzYuNjc1bDkuMDM2IDkuMDM1TDIwLjg0OC42NzVhMS4yMzEgMS4yMzEgMCAxIDEgMS43NDEgMS43NDFsLTkuMDM2IDkuMDM2eiIgZmlsbD0iI0ZGRiIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/styles/marketing/menu/close.svg
// module id = ./src/styles/marketing/menu/close.svg
// module chunks = 21